import React from 'react';
import parser from 'html-react-parser';
import { Icon } from '@iconify/react';

export default function Modal({ modalData }) {
  const { thumbUrl, details } = modalData;
  const { title, description, type, langages, platform, country, url, cta } =
    details;
  return (
    <div className="px-modal">
      <div className="single-project-box">
        <div className="row align-items-start">
          <div className="col-lg-7">
            <img className="border" src={thumbUrl} title alt="Thumbnail" />
          </div>
          <div className="col-lg-5 pt-4 pt-lg-0">
            {title && <h4>{parser(title)}</h4>}
            {description && <p>{parser(description)}</p>}
            <div className="about-content">
              <ul>
                {type && (
                  <li className="d-flex">
                    <span className="col-4 col-lg-3">Type:</span>
                    <span>{type}</span>
                  </li>
                )}
                {langages && (
                  <li className="d-flex">
                    <span className="col-4 col-lg-3">Langages:</span>
                    <span>{langages}</span>
                  </li>
                )}
                {platform && (
                  <li className="d-flex">
                    <span className="col-4 col-lg-3">Platform:</span>
                    <span>{platform}</span>
                  </li>
                )}
                {country && (
                  <li className="d-flex">
                    <span className="col-4 col-lg-3">Country:</span>
                    <span>{country}</span>
                  </li>
                )}
                {url && (
                  <li className="d-flex">
                    <span className="col-4 col-lg-3">Live URL:</span>
                    <span>{url}</span>
                  </li>
                )}
                {cta && cta.link && ( // Check if cta and cta.link exist
                <a
                  href={cta} // Use the URL from cta
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-btn" // Apply the button styling class
                  style={{ marginTop: '20px' }} // Add margin top for spacing
                >
                  <span>{cta.text ? cta.text : "View on Behance"}</span>{' '} {/* Use cta.text or default */}
                  <i className="d-flex">
                    {/* Ensure Icon component is correctly imported and used */}
                    <Icon icon="bi:arrow-right" />
                  </i>
                </a>
              )}
              <div></div>
              {url && ( // Check if cta and cta.link exist
                <a
                  href={url} // Use the URL from cta
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-btn" // Apply the button styling class
                  style={{ marginTop: '20px' }} // Add margin top for spacing
                >
                  <span>{url.text ? url.text : "View Live Site"}</span>{' '} {/* Use cta.text or default */}
                  <i className="d-flex">
                    {/* Ensure Icon component is correctly imported and used */}
                    <Icon icon="bi:arrow-right" />
                  </i>
                </a>
              )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
